document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  nav.toggleAttribute('data-open');
  toggle.setAttribute('aria-expanded', nav.hasAttribute('data-open') ? 'true' : 'false');
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-add-to-cart]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
});
